import React from 'react';
import './Infrastructure.css';
import PostDeTravail from './Poste_De_Travail.png';
import SolutionServeur from './Solution_Serveur.png';
import useCountUp from '../../Hook/useCountUp';
import AnimatedSection from '../../Hook/Block';
import InfrastructureImg from './Infratructures.png';
import ParFeu from './ParFeu.png';
import ReseauActif from './ReseauActif.png';
import ReseauWifi from './ResesauWifii.png';
import SEO from '../../Hook/Seo';
import BreadcrumbsSchema from '../../Hook/BreadcrumbsSchema';
import Vpn from './Vpn.png';
import VideoPresentationInformatique from '../../pages/Informatique/video_presentation_informatique.mp4';

const Infrastructure = ({ openTarifs, ville }) => {
  const clients1 = useCountUp(1500, 2000);

  // Formatage de la ville pour l'affichage (ex: epinal -> Épinal)
  const displayCity = ville 
    ? ville.charAt(0).toUpperCase() + ville.slice(1).replace(/-/g, ' ') 
    : "les Vosges";

  return (
    <>
      <SEO
        title={`Maintenance & Infogérance informatique à ${displayCity} | AM Services`}
        description={`Support postes/serveurs, sauvegardes et réseaux pour PME à ${displayCity}. Votre partenaire IT de proximité.`}
        path={ville ? `/infrastructure/${ville}` : "/infrastructure"}
        keywords={[
          "maintenance informatique",
          `informatique ${displayCity}`,
          "infogérance",
          "support IT",
          "sécurité informatique",
          "Vosges"
        ]}
      />
      <BreadcrumbsSchema />

      {/* 1. HERO VIDÉO IMMERSIF PLEIN ÉCRAN CORRIGÉ (100VH) */}
      <div className="infra-hero-container">
        <div className="infra-video-wrapper">
          <video
            src={VideoPresentationInformatique}
            autoPlay
            muted
            loop
            playsInline
            className="infra-background-video"
            aria-label={`Vidéo de présentation AM Services à ${displayCity}`}
          />
          <div className="infra-hero-overlay"></div>
        </div>

        <div className="infra-hero-center-text">
          <h1 className="infra-title">RÉSEAUX & INFRASTRUCTURE</h1>
          <p className="infra-lead">
            Chez AM Services, nous concevons et sécurisons vos installations à <span className="highlight-text-blue">{displayCity}</span> pour une connectivité fiable et performante.
          </p>
        </div>

        <div className="scroll-indicator" onClick={() => document.getElementById('infra-content-start').scrollIntoView({ behavior: 'smooth' })}>
          <span className="arrow"></span>
        </div>
      </div>

      {/* 2. GRANDS COMPOSANTS PROPRES SUR FOND BLANC ASYMTRIQUE */}
      <div className="infra-showcase-section" id="infra-content-start">
        
        {/* PREMIER ENSEMBLE DE SERVICES */}
        <div className="infra-animated-wrapper">
          <AnimatedSection
            sectionTitle={`Solutions d'Infrastructures - ${displayCity}`}
            direction="right"
            items={[
              { img: InfrastructureImg, alt: "Performance et monitoring", title: "Performance et monitoring", text: `Optimisation et surveillance réseau proactives pour nos clients à ${displayCity}.` },
              { img: SolutionServeur, alt: "Solutions serveurs", title: "Solutions serveurs", text: "Nous mettons en place des serveurs sur mesure, centralisés et hautement fiables." },
              { img: PostDeTravail, alt: "PC et postes de travail", title: "PC et postes de travail", text: "Nous vous conseillons et équipons vos équipes en PC fixes et portables." }
            ]}
            count={clients1}
            countLabel="Ordinateurs vendus"
            openTarifs={openTarifs}
          />
        </div>

        {/* DEUXIÈME ENSEMBLE DE SERVICES */}
        <div className="infra-animated-wrapper second-block-spacing">
          <AnimatedSection
            sectionTitle="Sécurité & Connectivité Périphérique"
            direction="left"
            items={[
              { img: ReseauActif, alt: "Réseau actif", title: "Réseau actif", text: "Supervision complète de votre infrastructure réseau active (VLAN, commutateurs) disponible 24/7." },
              { img: ParFeu, alt: "Pare-feu", title: "Pare-feu", title: "Protection Pare-feu", text: "Protection contre les intrusions et menaces internes via des solutions pare-feu avancées." },
              { img: ReseauWifi, alt: "Réseau Wi-Fi", title: "Réseau Wi-Fi", text: `Audit et déploiement de Wi-Fi professionnel sécurisé WPA3 pour vos locaux à ${displayCity}.` },
              { img: Vpn, alt: "VPN sécurisé", title: "VPN sécurisé", text: "Accès distant sécurisé pour vos collaborateurs en télétravail." }
            ]}
            openTarifs={openTarifs}
          />
        </div>

      </div>
    </>
  );
};

export default Infrastructure;